export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_IMPERSONATION_REQUEST = 'AUTH_IMPERSONATION_REQUEST';
export const AUTH_RESET_IMPERSONATION_REQUEST =
	'AUTH_RESET_IMPERSONATION_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
